import {Component,Input, ViewChild} from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { PlatformLocation } from '@angular/common';
export interface ConfirmModel {
  title:string;
  message:string;
}
@Component({  
    selector: 'confirm',
    template: `<div class="vertical-alignment-helper"><div class="modal-dialog" *ngIf="rerenderLogoutpopup">
                <div class="modal-content" >
         
                     <div class="poupupTitle">
                     <h5 class="modal-title">{{title || 'Confirm'}}</h5>
                   </div>
               
               
                   <div class="modal-body">
                   <div class="firstPopup">
                     <p class="text-center">{{message}}</p>
                     </div>
                   </div>
                   <div class="modal-footer text-center">
                     <button type="button" class="btn btn-default btn-orange" (click)="confirm()">Ok</button>
                     <button type="button" class="btn btn-default btn-orange" (click)="cancel()">Cancel</button>
                   </div>
                 </div>
              </div></div>`,
              providers : [PopupLogoutComponent]
})
export class PopupLogoutComponent extends DialogComponent<ConfirmModel, boolean> implements ConfirmModel {
  title: string;
  message: string;
  rerenderLogoutpopup: boolean;
  constructor(dialogService: DialogService, location: PlatformLocation) {    
    super(dialogService);
     this.rerenderLogoutpopup =true;
      location.onPopState(() => {
     this.close();
    });
   
  }
  public confirm() {
    this.result = true;
    this.close();
  }
  cancel() {
    this.result = false;
    this.close();
  }


}



// WEBPACK FOOTER //
// ./src/app/users/popup/popup-logout.component.ts